/* DON'T EDIT THIS FILE: edit original and run build again */ import { useRealmHandler } from "../../framework/app-state/app-state-context.ts";
import { UserProfile } from "../../framework/auth-profile/schema.ts";
import { logoutPath } from "../../framework/auth-ui/logout-path.ts";
import { useAccountAndLoadIt } from "../../framework/auth-ui/use-account-and-load-it.front.ts";
import { AccountContext } from "../../framework/auth-ui/use-account.ts";
import { TenantIndex } from "../../framework/tenant-collection/tenant-index-entry.ts";
import { guessCurrentTenant } from "../../framework/tenant-current-tenant/guess-current-tenant.ts";
import { useFetchTenantHandler } from "../../framework/tenant-current-tenant/use-fetch-tenant-handler.ts";
import { SimpleErrorPage } from "../../framework/theme-pages/error-page.front.tsx";
import { LoadingPage } from "../../framework/theme/loading.tsx";
import { notifyUserToTracker } from "../../framework/track/track.ts";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { RealmAccountMismatchErrorPage } from "./error-pages.front.tsx";

export const AccountWrapper = ({
  tenantIndex,
  children,
}: {
  tenantIndex: TenantIndex;
  children: React.ReactNode;
}) => {
  const [
    loadingAccount,
    account,
    profile,
    roles,
    privateProfile,
    firstTimeModals,
  ] = useAccountAndLoadIt();
  const { pathname } = useLocation();
  const realmHandler = useRealmHandler();
  useEffect(() => {
    notifyUserToTracker(
      account ?? undefined,
      profile ?? undefined,
      roles ?? undefined
    );
  }, [account, profile, roles]);
  const realmFromUrl = realmHandler.getCode();
  const currentTenant = guessCurrentTenant(
    tenantIndex,
    realmFromUrl,
    profile ?? undefined
  );
  const [loadingTenant, tenantHandler, tenantError] =
    useFetchTenantHandler(currentTenant);
  if (loadingAccount || loadingTenant) {
    return <LoadingPage />;
  }
  if (tenantError !== null || !tenantHandler) {
    return <SimpleErrorPage title="Tenant no encontrado o error al cargarlo" />;
  }
  // eslint-disable-next-line no-restricted-properties
  if (profile?.tenant && pathname !== logoutPath) {
    const nonEmptyProfile = profile as UserProfile;
    // logout page is not in tenant, thus we can reference directly
    const userRealm = profile.realm;
    if (userRealm !== realmFromUrl) {
      return (
        <RealmAccountMismatchErrorPage
          profile={nonEmptyProfile}
          userRealm={userRealm}
          realmFromUrl={realmFromUrl}
        />
      );
    }
  }
  return (
    <AccountContext.Provider
      value={{
        account,
        profile,
        privateProfile,
        roles,
        firstTimeModals,
        tenantHandler,
        tenantIndex,
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};
